import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/default/images/loading.png'


const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass([
      'fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50',
      'overflow-hidden bg-black bg-opacity-50',
      'flex flex-col items-center justify-center space-y-2',
    ])
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"3rem"},
  class: "animate-spin",
  src: _imports_0,
  alt: "loading"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}